module.exports = __webpack_public_path__ + "media/src/assets/images/case-pic1-3b3322811b76396cc9d7fba778d02faa.png";